import { createSelector } from '@ngrx/store';
import { BuyerState } from '../state';
import { getBuyerState } from '../feature-selector';
import { SearchState } from './search.state';

const getSearchState = createSelector(
  getBuyerState,
  (state: BuyerState) => state && state.search,
);

export const getSearchQuery = createSelector(
  getSearchState,
  (state: SearchState) => state && state.searchQuery,
);

export const isSearchInputFocused = createSelector(
  getSearchState,
  (state: SearchState) => state && state.isSearchInputFocused,
);

export const isSearchFromHeaderBar = createSelector(
  getSearchState,
  (state: SearchState) => state && state.isSearchFromHeaderBar,
);
export const getPageNumberWhenUserSearchedFromHeaderBar = createSelector(
  getSearchState,
  (state: SearchState) => state && state.pageNumberWhenUserSearchedFromHeaderBar,
);

export const getNavigatedToSearch = createSelector(
  getSearchState,
  (state: SearchState) => state && state.navigatedToSearch && !state.isSearchFromHeaderBar
);

